import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/index.css";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { I18nProvider } from "@/context/I18nContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import NewsletterPopup from "@/components/NewsletterPopup";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import Bundle from "@/pages/Bundle";
import OrderTrack from "@/pages/OrderTrack";
import GiftCard from "@/pages/GiftCard";
import ReferralCatch from "@/pages/ReferralCatch";
import Wholesale from "@/pages/Wholesale";
import CorporateCatering from "@/pages/CorporateCatering";
import Contact from "@/pages/Contact";
import { BlogList, BlogDetail } from "@/pages/Blog";
import NotFound from "@/pages/NotFound";

function Shell({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[color:var(--brunchi-paper)] text-[color:var(--brunchi-ink)]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <CartDrawer />
      <NewsletterPopup />
      <Toaster position="bottom-right" theme="light" richColors />
    </div>
  );
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/shop/:slug" element={<ProductDetail />} />
      <Route path="/bundle" element={<Bundle />} />
      <Route path="/gift-card" element={<GiftCard />} />
      <Route path="/wholesale" element={<Wholesale />} />
      <Route path="/corporate-catering" element={<CorporateCatering />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/blog" element={<BlogList />} />
      <Route path="/blog/:slug" element={<BlogDetail />} />
      <Route path="/r/:code" element={<ReferralCatch />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/subscription/success" element={<PaymentSuccess />} />
      <Route path="/subscription/cancel" element={<PaymentCancel />} />
      <Route path="/track/:orderNumber" element={<OrderTrack />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/account" element={<Account />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Shell>
              <AppRoutes />
            </Shell>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </I18nProvider>
  );
}
